import axios, { AUTH_MULTI_ACCOUNT_PREFIX } from 'src/clients/axios';
import {
  AddAChildParams,
  AddAchildResponse,
  UpdateRelationParams,
  UpdateRelationResponse,
} from 'src/models/BusinessPayment/MAM/MAM';

export const addAChild = (data: AddAChildParams) => {
  return axios.request<AddAchildResponse>({
    method: 'post',
    url: `${AUTH_MULTI_ACCOUNT_PREFIX}`,
    data,
  });
};

export const updateParentChildRelation = (data?: UpdateRelationParams) => {
  return axios.request<UpdateRelationResponse>({
    method: 'put',
    url: `${AUTH_MULTI_ACCOUNT_PREFIX}`,
    data,
  });
};
